import { Utils } from '@sbs/uikit-constructor';
import { APPOINTMENT_MANAGEMENT } from '@/constants/index.js';
import { EVENT_TYPES, PERIOD_TYPES, LINK_TYPES, VIDEO_RECORD_TYPES, AUTOMATIC_PASS_AFTER_TYPES } from './index.js';

export const speakerDefault = () => ({
    id: Utils.Helpers.getRandomId(),
    content: {
        name: '',
        description: '',
        photo_file: {
            attachment_id: null,
        },
    },
});

export const videoDefault = () => ({
    id: Utils.Helpers.getRandomId(),
    file: null,
    media_lib: {
        link: null,
        duration: null,
    },
    cover: null,
    subtitle: null,
});

export const scheduleEventDefault = () => ({
    id: Utils.Helpers.getRandomId(),
    content: {
        link: '',
        place: '',
        time: '',
        name: '',
        description: '',
        heading_speakers: '',
        speakers: {
            items: [speakerDefault()],
        },
        video: videoDefault(),
    },
    settings: {},
});

export const scheduleDayDefault = () => ({
    id: Utils.Helpers.getRandomId(),
    content: {
        date: '',
        schedule_items: {
            items: [scheduleEventDefault()],
        },
    },
});

// eslint-disable-next-line max-lines-per-function
export const eventDataDefault = () => ({
    content: {
        title: '',
        heading_description: '',
        text: '',
        link: '',
        place: '',
        date: '',
        time: '',
        cover_file: {
            attachment_id: null,
        },
        heading_speakers: '',
        speakers: {
            items: [speakerDefault()],
        },
        heading_schedule: '',
        schedule: {
            items: [
                scheduleDayDefault(),
                scheduleDayDefault(),
            ],
        },
        video: videoDefault(),
    },
    settings: {
        event_type: EVENT_TYPES.ONLINE,
        link_type: LINK_TYPES.OVERALL,
        period: PERIOD_TYPES.SINGLE,
        video_record: {
            enabled: true,
            is_published: false,
            type: VIDEO_RECORD_TYPES.COMMON,
        },
        statistics: {
            enabled: false,
        },
        score: {
            is_enabled: false,
            count: null,
        },
        automatic_pass: {
            enabled: false,
            pass_after: [AUTOMATIC_PASS_AFTER_TYPES.AFTER_ACCEPT_VISIT],
        },
        assignment_type: APPOINTMENT_MANAGEMENT.INDIVIDUAL_EXECUTION,
    },
});
